import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Component/Routing/Router";
import { EsimProvider } from "./Component/Pages/Products/Esim/Edata";
import { AuthProvider } from "./context/AuthContext";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 850,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
      delay: 40,
      mirror: false,
    });
  }, []);

  return (
    <AuthProvider>
      <EsimProvider>
        <Router />
      </EsimProvider>
    </AuthProvider>
  );
}

export default App;
